.container {
  width: 100vw;
  height: 100vh;
  background-color: var(--fully-white);
}
